import ConversationType from 'owa-service/lib/contract/ConversationType';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import Item from 'owa-service/lib/contract/Item';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { logUsage } from 'owa-analytics';
import { MailListRowDataType } from 'mini-mail-list-store/lib/store/schema/MailListRowDataType';
import { stringItemIdsTogether } from 'mini-mail-list-store/lib/utils/logMaillistItems';

import {
    notificationQueue,
    onReload,
} from 'mini-mail-list-actions/lib/actions/notifications/rowNotificationHandler';

export const addVisibilityEventListener = (): void => {
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            const shouldReload = notificationQueue?.shouldReload?.[0];
            const tableViewForReload = notificationQueue?.shouldReload?.[1];
            if (shouldReload) {
                onReload(tableViewForReload);
            } else {
                let item:
                    | MailListRowDataType
                    | ConversationType; /*Either the row or conversation to add/update/delete*/
                let tableView: TableView;
                let functionToPerform;
                notificationQueue.actionList.forEach(actionItem => {
                    try {
                        item = actionItem?.[1]?.[0];
                        tableView = actionItem?.[1]?.[1];
                        functionToPerform = actionItem?.[0];
                        functionToPerform(item, tableView);
                    } catch (err) {
                        logUsage(
                            'InvalidActionItemValues',
                            {
                                ac: functionToPerform,
                                id: item?.ConversationId?.Id || (item as Item)?.ItemId?.Id,
                                iIds: stringItemIdsTogether(tableView?.itemIds),
                            },
                            { isCore: true }
                        );
                    }
                });
            }
            notificationQueue.actionList = [];
            notificationQueue.shouldReload = [
                false,
                getSelectedTableView() /*Just as a backup, should never be called when the first argument is false*/,
            ];
        }
    });
};
